import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {Wheel} from "react-custom-roulette";
import {Button} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

export default function Spinner() {
    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const data = [
        { option: 'Clement', style: { backgroundColor: 'red', textColor: 'white' } },
        { option: 'Albert', style: { backgroundColor: 'white', textColor: 'black' } },
        { option: 'Stanley' },
    ]

    const handleSpinClick = () => {
        const newPrizeNumber = Math.floor(Math.random() * data.length)
        setPrizeNumber(newPrizeNumber)
        setMustSpin(true)
    }

  return (
    <div>
        <Link to='/' className="back-button">
            <ArrowBackIosIcon style={{color: 'red'}}/>
        </Link>
        <div style={{marginTop: 80}}>
            <div className="box-container">
                <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumber}
                    data={data}
                    backgroundColors={['#3e3e3e', '#df3428']}
                    textColors={['#ffffff']}
                    onStopSpinning={() => {
                        setMustSpin(false)
                    }}
                />
                <Button variant="contained" color="secondary" style={{borderRadius: 40, width: '100%', height: 70, marginTop: 35}} onClick={handleSpinClick}> Spin </Button>
            </div>
        </div>
    </div>
  );
}
